'use strict';

var CommonChars = require('../var/CommonChars');

var HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;

function periodSplit(str) {
  return str.split(HALF_WIDTH_PERIOD);
}

module.exports = periodSplit;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/periodSplit.js
// module id = 109
// module chunks = 0